import React, { useState } from "react";
import "../../assets/notFound.css";  
import { Link } from "react-router-dom";

const NotFound = () => {
    const [isPaused, setIsPaused] = useState(false);

    const togglePause = () => {
        setIsPaused(!isPaused);
    };

    return (
        <div className={`not-found-page flex flex-col items-center justify-center h-[100vh] ${isPaused ? "paused" : ""}`}>
            <div className={`glitch-wrapper ${isPaused ? "paused" : ""}`}>
                <div className="glitch-text">ERROR 404: Not Found</div>
            </div>
            <div className="flex items-center justify-center">
                <Link to={"/"} className="btn" type="button" onMouseEnter={togglePause} onMouseLeave={togglePause}>
                    Back To Site
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
